/// <amd-module name="Wit/BoardsHub/Common/BoardsWorkItem" />
import { ObservableValue } from "VSS/Core/Observable";
import { IVssPageContext } from "VSS/Platform/Context";
import { ClientWorkItem, ObservableClientWorkItem } from "Wit/ClientWorkItemService/IClientWorkItem";
import { IFieldEntry } from "Wit/Common/Generated/Contracts";
import { INamedFieldDataDictionary } from "Wit/WorkItemDataManager/Contracts";
import { IWorkItem } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { IBoardsWorkItem, IItemAnnotations, IObservableBoardsWorkItem } from "./Interfaces";

export class BoardsWorkItem extends ClientWorkItem implements IBoardsWorkItem {
    public annotations: IItemAnnotations | undefined;
    public isTitleEditing: ObservableValue<boolean>;
    public constructor(
        fields: INamedFieldDataDictionary,
        referenceFields: IFieldEntry[] | undefined,
        extensionId: string,
        pageContext?: IVssPageContext,
        workItemPromise?: Promise<IWorkItem>
    ) {
        super(fields, referenceFields);
        this._extensionId = extensionId;
        this.isTitleEditing = new ObservableValue(false);
        if (pageContext && workItemPromise) {
            this.hydrate(pageContext, workItemPromise);
        }
    }

    /**
     * Create a new work item from an array of field values.
     */
    public static fromValues(
        values: any[],
        fieldReferenceNames: string[],
        fieldEntries: IFieldEntry[] | undefined,
        extensionId: string
    ): IBoardsWorkItem {
        const fields: INamedFieldDataDictionary = {};
        for (let i = 0; i < fieldReferenceNames.length; i++) {
            fields[fieldReferenceNames[i]] = values[i];
        }

        return new BoardsWorkItem(fields, fieldEntries, extensionId);
    }
}

export class BoardsObservableWorkItem extends ObservableClientWorkItem<IBoardsWorkItem> implements IObservableBoardsWorkItem {
    public expandedAnnotation: string | undefined;
    public addingAnnotation: boolean | undefined;
    public setOpenAnnotation(annotationName?: string, adding?: boolean) {
        this.expandedAnnotation = annotationName;
        this.addingAnnotation = adding;
        this.notify();
    }
}
